import { render, staticRenderFns } from "./SettingsMobile.vue?vue&type=template&id=01dd015d&scoped=true"
import script from "./SettingsMobile.vue?vue&type=script&lang=js"
export * from "./SettingsMobile.vue?vue&type=script&lang=js"
import style0 from "./SettingsMobile.vue?vue&type=style&index=0&id=01dd015d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dd015d",
  null
  
)

export default component.exports